export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  genres: string[];
  region: string;
  duration: number;
  director: string;
  cast: string[];
  rating: number;
  popularity: number;
  addedDate: string;
  category: string;
  tags: string[];
  poster: string;
  backdrop: string;
  featured: boolean;
  synopsis: string;
  editorReviewTitle: string;
  editorReview: string;
}

export const movies: Movie[] = [
  {
    id: 'silent-confession',
    title: '沉默的告白',
    originalTitle: 'The Silent Confession',
    year: 2019,
    genres: ['剧情', '伦理'],
    region: '美国',
    duration: 128,
    director: 'Marcus Ellery',
    cast: ['Grace Whitmore', 'Daniel Foss', 'Elena Ruiz', 'Paul Renner'],
    rating: 8.6,
    popularity: 96,
    addedDate: '2026-09-28',
    category: 'drama',
    tags: ['婚姻困境', '道德抉择', '小镇生活'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20moody%20movie%20poster%20of%20a%20lone%20woman%20standing%20in%20a%20foggy%20new%20england%20town%20at%20dusk%2C%20muted%20slate%20blue%20and%20amber%20tones%2C%20dramatic%20rain%20light%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail%2C%20melancholic%20atmosphere&width=600&height=900&seq=poster-drama-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Atmospheric%20wide%20shot%20of%20an%20empty%20rainy%20street%20in%20a%20small%20american%20town%20at%20blue%20hour%2C%20street%20lamps%20glowing%20warm%20amber%2C%20moody%20cinematic%20teal%20and%20orange%20palette%2C%20film%20grain%2C%20dramatic%20depth%2C%20no%20text&width=1600&height=900&seq=backdrop-drama-01&orientation=landscape',
    featured: true,
    synopsis: '在一座安静的新英格兰小镇，家庭主妇格蕾丝发现丈夫多年前隐瞒的一桩旧案，与她的邻居和挚友都脱不开干系。她必须在维系完整家庭与坚守良知之间做出选择。影片以克制的镜头语言，一层层揭开看似体面的中产生活背后的裂痕，把“沉默”本身塑造成一种共谋。随着真相逼近，格蕾丝意识到，说出实话的代价也许比沉默更沉重。',
    editorReviewTitle: '当沉默成为共谋：一次关于良知的缓慢审判',
    editorReview: '《沉默的告白》最动人的地方，不在于它给出了答案，而在于它把问题交还给了观众。导演用大量静止的长镜头，把格蕾丝的犹豫拍成了一种物理性的重量。Grace Whitmore 的表演近乎内敛到极致，一个眼神的闪避就足以交代十年的婚姻。影片拒绝廉价的道德审判，让每个人物的立场都具备可理解的理由，这正是它作为伦理片最珍贵的地方。',
  },
  {
    id: 'ash-and-vow',
    title: '灰烬之约',
    originalTitle: 'Ash and Vow',
    year: 2021,
    genres: ['剧情', '家庭'],
    region: '美国',
    duration: 134,
    director: 'Nora Vasquez',
    cast: ['Helen Marsh', 'Thomas Doyle', 'Ruth Adler', 'Ben Coyle'],
    rating: 8.3,
    popularity: 88,
    addedDate: '2026-09-21',
    category: 'family',
    tags: ['家族秘密', '遗产', '原谅'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20burning%20letter%20held%20in%20weathered%20hands%2C%20warm%20ember%20orange%20light%20against%20dark%20charcoal%20background%2C%20dramatic%20chiaroscuro%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-family-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20old%20american%20family%20farmhouse%20at%20sunset%2C%20warm%20golden%20dust%20in%20the%20air%2C%20long%20shadows%2C%20melancholic%20nostalgic%20mood%2C%20film%20grain%2C%20teal%20and%20orange%20palette%2C%20no%20text&width=1600&height=900&seq=backdrop-family-01&orientation=landscape',
    featured: true,
    synopsis: '父亲去世后，三兄妹回到家乡处理遗产，却在一封被烧掉一半的信里读到一个从未被提起的名字。随着旧照片与账本被翻出，他们不得不重新理解父亲的一生，也重新面对彼此之间那些被刻意绕开的话题。影片把“遗产”从一个法律概念，变成了一份关于记忆与宽恕的考卷，追问血缘究竟意味着责任还是枷锁。',
    editorReviewTitle: '遗产之下：一个家族如何与记忆和解',
    editorReview: '家庭伦理片很容易滑向煽情，但《灰烬之约》保持了难得的冷静。导演 Nora Vasquez 把冲突都放在餐桌与走廊这些日常空间里，让争吵显得真实而不戏剧化。影片最重要的贡献，是它承认“原谅”并不是一个必选项——有时候，理解本身就是终点。',
  },
  {
    id: 'glass-coast',
    title: '玻璃海岸',
    originalTitle: 'Glass Coast',
    year: 2018,
    genres: ['剧情', '社会'],
    region: '美国',
    duration: 119,
    director: 'Ian Broderick',
    cast: ['Sofia Lang', 'Miles Grant', 'Carla Dean', 'Owen Pike'],
    rating: 8.1,
    popularity: 82,
    addedDate: '2026-09-12',
    category: 'society',
    tags: ['阶层', '环境争议', '社区'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20shattered%20glass%20wave%20edge%20on%20a%20stormy%20beach%2C%20cold%20cyan%20and%20soft%20sand%20tones%2C%20abstract%20emotional%20composition%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-society-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20stormy%20coastline%20with%20crashing%20waves%20and%20a%20small%20factory%20on%20the%20cliff%2C%20overcast%20grey%20sky%2C%20cold%20distant%20mood%2C%20film%20grain%2C%20desaturated%20palette%20with%20subtle%20warm%20light%2C%20no%20text&width=1600&height=900&seq=backdrop-society-01&orientation=landscape',
    featured: false,
    synopsis: '一名环境记者回到童年生活的沿海小镇，调查一家工厂排放对社区的长期影响。她很快发现，公开真相会让赖以生存的就业机会消失，而沉默则意味着更多人受到伤害。影片不站队，而是让每一种立场都拥有其现实重量，展现了一个社区在利益与健康之间的撕裂。',
    editorReviewTitle: '没有反派的悲剧：一部关于选择的社区寓言',
    editorReview: '《玻璃海岸》最聪明之处，是不把任何一方写成恶人。记者不是圣人，工人也不是帮凶，所有人都在有限的选项里艰难求生。这种对灰色地带的尊重，让影片超越了一般的社会议题片，成为一面照见现实困境的镜子。',
  },
  {
    id: 'edge-of-lies',
    title: '谎言边城',
    originalTitle: 'Edge of Lies',
    year: 2020,
    genres: ['剧情', '悬疑'],
    region: '美国',
    duration: 122,
    director: 'Rebecca Stone',
    cast: ['Julia Vance', 'Aaron Cole', 'Nina Petrov', 'Sam Burke'],
    rating: 8.4,
    popularity: 91,
    addedDate: '2026-09-05',
    category: 'drama',
    tags: ['谎言', '身份', '边界小镇'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20solitary%20silhouette%20at%20a%20desert%20border%20town%20at%20night%2C%20harsh%20neon%20and%20cold%20blue%20shadows%2C%20tense%20suspense%20atmosphere%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-drama-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20empty%20desert%20highway%20at%20dusk%20near%20a%20border%20town%2C%20lone%20car%20headlights%2C%20deep%20purple%20blue%20sky%20with%20warm%20horizon%20glow%2C%20film%20grain%2C%20tense%20mood%2C%20no%20text&width=1600&height=900&seq=backdrop-drama-02&orientation=landscape',
    featured: false,
    synopsis: '为了给生病的母亲筹钱，一位单亲母亲接受了替人顶罪的交易。谎言像滚雪球般越滚越大，她逐渐被卷入一场关于身份、责任与尊严的漩涡。当自由与家人无法两全，她只能一次次重新定义“对”与“错”。影片锋利地追问：一个被生活逼迫的人，是否还拥有选择善良的余地。',
    editorReviewTitle: '谎言滚成雪球之后，人还能剩下什么',
    editorReview: 'Julia Vance 贡献了职业生涯最紧绷的表演。她把一个被逼到墙角的女性的恐惧、算计与母爱，压缩在极少的台词里。导演用大量手持镜头制造不安感，让观众始终站在角色的呼吸里，而不是安全的旁观席上。',
  },
  {
    id: 'testimony-long-night',
    title: '长夜的证词',
    originalTitle: 'Testimony of the Long Night',
    year: 2022,
    genres: ['剧情', '社会'],
    region: '美国',
    duration: 141,
    director: 'Marcus Ellery',
    cast: ['Claire Hodges', 'Victor Roan', 'Dina Meyer', 'Leo Franks'],
    rating: 8.7,
    popularity: 94,
    addedDate: '2026-08-30',
    category: 'society',
    tags: ['司法', '真相', '勇气'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20witness%20silhouette%20under%20a%20single%20harsh%20interrogation%20lamp%2C%20deep%20charcoal%20and%20cold%20blue%2C%20high%20contrast%20dramatic%20lighting%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-society-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20empty%20courthouse%20hallway%20at%20night%2C%20long%20shadows%20and%20cold%20fluorescent%20light%20with%20one%20warm%20window%20glow%2C%20film%20grain%2C%20tense%20solemn%20mood%2C%20no%20text&width=1600&height=900&seq=backdrop-society-02&orientation=landscape',
    featured: true,
    synopsis: '一个普通的夜班保安成为一桩旧案的唯一目击者。作证意味着得罪整个社区，沉默则意味着让一个无辜者继续蒙冤。影片用近乎纪录片的冷静，跟随他在漫长的几夜里反复权衡，让“作证”这个简单的动作，变成一场对勇气的严苛审判。当真相与代价同时摆在面前，他必须决定自己究竟是谁。',
    editorReviewTitle: '一个人的证人席：勇气的成本有多高',
    editorReview: '近年来最扎实的司法伦理片之一。它没有把主角塑造成英雄，而是把一个普通人放在聚光灯下，逼他看着自己。Claire Hodges 与 Victor Roan 的对手戏火花四溅，几乎每一场都像在拆解人性的零件。',
  },
  {
    id: 'two-faces-summer',
    title: '双面盛夏',
    originalTitle: 'Two Faces of Summer',
    year: 2017,
    genres: ['爱情', '伦理'],
    region: '美国',
    duration: 112,
    director: 'Lily Carmichael',
    cast: ['Emma Frost', 'Jared Hale', 'Mia Kent', 'Carlos Vega'],
    rating: 7.8,
    popularity: 76,
    addedDate: '2026-08-22',
    category: 'romance',
    tags: ['爱情', '背叛', '成长'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20couple%20standing%20apart%20on%20a%20sunlit%20summer%20porch%2C%20warm%20golden%20haze%20and%20soft%20dusty%20pink%20tones%2C%20romantic%20bittersweet%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-romance-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20sunlit%20summer%20lake%20house%20porch%20with%20flowing%20white%20curtains%2C%20warm%20golden%20hour%20haze%2C%20nostalgic%20bittersweet%20mood%2C%20soft%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-romance-01&orientation=landscape',
    featured: false,
    synopsis: '一段看似完美的夏日恋情，因一次坦白而彻底失衡。两个人在同一个夏天里，各自藏着不同的期待与秘密。影片用夏日特有的明亮光影，反衬情感中的阴影，探讨承诺、自由与自我之间的拉扯：当爱一个人意味着放弃一部分自己，这段感情还值得继续吗。',
    editorReviewTitle: '在最明亮的季节，看清最暗的心事',
    editorReview: '一部被低估的爱情伦理小品。它没有狗血桥段，而是把一段关系里那些“说不出口”的部分拍得极其精确。导演对光影的运用堪称教科书级，让整个夏天既甜蜜又带着隐隐的窒息感。',
  },
  {
    id: 'the-road-back',
    title: '归途未远',
    originalTitle: 'The Road Back',
    year: 2023,
    genres: ['剧情', '家庭'],
    region: '美国',
    duration: 126,
    director: 'Nora Vasquez',
    cast: ['Grace Whitmore', 'Peter Sloan', 'Amara Bell', 'Jonah Reed'],
    rating: 8.5,
    popularity: 89,
    addedDate: '2026-08-15',
    category: 'family',
    tags: ['亲情', '回归', '救赎'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20parent%20and%20child%20silhouette%20walking%20down%20a%20long%20country%20road%20at%20sunset%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20hopeful%20restrained%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-family-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20long%20empty%20country%20road%20through%20amber%20fields%20at%20sunset%2C%20distant%20figure%20walking%2C%20warm%20melancholic%20hopeful%20mood%2C%20soft%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-family-02&orientation=landscape',
    featured: false,
    synopsis: '服刑十年后，一个男人回到他离开时还年幼的女儿身边。他想弥补，却发现时间留下的裂缝并非用力就能填平。影片以极其耐心的节奏，记录一个家庭如何从陌生重新走向理解，追问“原谅”到底是给予对方，还是放过自己。',
    editorReviewTitle: '回家的路很长，和解更远',
    editorReview: 'Nora Vasquez 再次证明了她是当代家庭伦理叙事最好的作者之一。影片拒绝廉价团圆，把每一次试探性的靠近都拍得小心翼翼，让最后的相拥拥有了真实的分量。',
  },
  {
    id: 'beneath-still-water',
    title: '静水之下',
    originalTitle: 'Beneath Still Water',
    year: 2016,
    genres: ['剧情', '伦理'],
    region: '美国',
    duration: 108,
    director: 'Ian Broderick',
    cast: ['Helen Marsh', 'Owen Pike', 'Sofia Lang'],
    rating: 7.9,
    popularity: 71,
    addedDate: '2026-08-08',
    category: 'drama',
    tags: ['记忆', '创伤', '真相'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20still%20dark%20lake%20surface%20reflecting%20trees%2C%20deep%20green%20and%20muted%20gold%2C%20quiet%20haunting%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-drama-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20still%20misty%20lake%20at%20dawn%20with%20reflecting%20dark%20forest%2C%20soft%20muted%20green%20and%20gold%20light%2C%20quiet%20haunting%20atmosphere%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-drama-03&orientation=landscape',
    featured: false,
    synopsis: '一场家庭聚会，因为一通意外的电话被彻底打乱。多年前被全家默契遗忘的往事，重新浮上水面。影片像静水一样表面平静，底下却暗流涌动，探讨记忆的选择性遗忘如何塑造一个人、也伤害一个人，追问我们是否有权替他人决定该记住什么。',
    editorReviewTitle: '被遗忘的，从未真正消失',
    editorReview: '一部安静却后劲十足的伦理片。它几乎不依赖配乐，全靠表演与空间调度传递压迫感。看完之后那种沉在水底的感觉，会在心里留很久。',
  },
  {
    id: 'borrowed-lives',
    title: '交换人生',
    originalTitle: 'Borrowed Lives',
    year: 2021,
    genres: ['爱情', '伦理'],
    region: '美国',
    duration: 115,
    director: 'Lily Carmichael',
    cast: ['Mia Kent', 'Carlos Vega', 'Nina Petrov', 'Aaron Cole'],
    rating: 7.6,
    popularity: 73,
    addedDate: '2026-08-01',
    category: 'romance',
    tags: ['欲望', '选择', '都市'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20two%20overlapping%20mirrored%20portraits%20of%20a%20woman%20in%20a%20city%20window%2C%20cool%20reflective%20light%20with%20warm%20accent%2C%20modern%20intimate%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-romance-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20rainy%20modern%20city%20street%20at%20night%20seen%20through%20a%20warm%20lit%20window%2C%20reflective%20wet%20asphalt%2C%20cool%20blue%20with%20warm%20accents%2C%20film%20grain%2C%20modern%20intimate%20mood%2C%20no%20text&width=1600&height=900&seq=backdrop-romance-02&orientation=landscape',
    featured: false,
    synopsis: '一对都市夫妻在一次搬家中，无意间过上了“别人的人生”。物质的跃升带来了轻松的假象，也让两人渐渐迷失了原本的自我。影片用冷峻的都市光影，审视欲望与真实之间的落差，追问我们究竟是在追求幸福，还是在追求别人眼里的幸福。',
    editorReviewTitle: '借来的生活，终究要还',
    editorReview: '影片对都市中产心理的刻画相当精准。它没有给出道德结论，而是把选择的后果摊开，让观众自己站队。两位主演的化学反应让这段关系真实可信。',
  },
  {
    id: 'seventh-witness',
    title: '第七个证人',
    originalTitle: 'The Seventh Witness',
    year: 2020,
    genres: ['剧情', '悬疑', '社会'],
    region: '美国',
    duration: 130,
    director: 'Rebecca Stone',
    cast: ['Victor Roan', 'Julia Vance', 'Leo Franks', 'Dina Meyer'],
    rating: 8.2,
    popularity: 85,
    addedDate: '2026-07-25',
    category: 'society',
    tags: ['真相', '群像', '正义'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20seven%20empty%20chairs%20in%20a%20dimly%20lit%20room%2C%20cold%20blue%20shadows%20with%20one%20warm%20lamp%2C%20mysterious%20solemn%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-society-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20empty%20dimly%20lit%20community%20hall%20with%20rows%20of%20chairs%20at%20night%2C%20cold%20blue%20shadows%20and%20one%20warm%20lamp%2C%20film%20grain%2C%20mysterious%20solemn%20mood%2C%20no%20text&width=1600&height=900&seq=backdrop-society-03&orientation=landscape',
    featured: false,
    synopsis: '七个目击者，七段互相矛盾的证词。真相在群像叙事中被一再打碎、重组。影片用多重视角结构，让观众像侦探一样在谎言与记忆的夹缝中寻找线索，也逼我们反思：当每个人都“只说了对自己有利的那部分真相”，正义还如何可能。',
    editorReviewTitle: '七段证词，一个破碎的真相',
    editorReview: '结构精巧，野心十足。导演用罗生门式的多视角叙事，把一桩案件拍成了一场关于人性与记忆的集体实验。每一段新证词都会让你推翻上一段的判断，观影体验极其过瘾。',
  },
  {
    id: 'hothouse',
    title: '温床',
    originalTitle: 'Hothouse',
    year: 2019,
    genres: ['剧情', '爱情'],
    region: '美国',
    duration: 106,
    director: 'Ian Broderick',
    cast: ['Emma Frost', 'Thomas Doyle', 'Ruth Adler'],
    rating: 7.4,
    popularity: 66,
    addedDate: '2026-07-18',
    category: 'romance',
    tags: ['控制', '依赖', '边界'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20greenhouse%20with%20dense%20tropical%20plants%20and%20hazy%20light%2C%20humid%20emerald%20and%20amber%20tones%2C%20claustrophobic%20intimate%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-romance-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20inside%20a%20hazy%20greenhouse%20filled%20with%20dense%20tropical%20plants%20and%20warm%20diffused%20light%2C%20humid%20emerald%20and%20amber%20tones%2C%20film%20grain%2C%20claustrophobic%20intimate%20mood%2C%20no%20text&width=1600&height=900&seq=backdrop-romance-03&orientation=landscape',
    featured: false,
    synopsis: '一段关系在温室般的呵护中逐渐温室化。当关心变成控制，依赖变成枷锁，两个曾经相爱的人开始意识到，他们正把自己养成彼此无法离开的样子。影片细腻地拆解情感中“为你好”的边界，追问爱与控制之间那条模糊的线。',
    editorReviewTitle: '当爱变成温室，谁先窒息',
    editorReview: '一部关于情感边界的锋利之作。影片用温室这个意象贯穿始终，把一段逐渐失衡的关系剖得清清楚楚。Emma Frost 的表演层次分明，令人不寒而栗。',
  },
  {
    id: 'the-last-letter',
    title: '最后一封信',
    originalTitle: 'The Last Letter',
    year: 2015,
    genres: ['剧情', '家庭'],
    region: '美国',
    duration: 102,
    director: 'Marcus Ellery',
    cast: ['Helen Marsh', 'Sam Burke', 'Carla Dean'],
    rating: 8.0,
    popularity: 69,
    addedDate: '2026-07-10',
    category: 'family',
    tags: ['告别', '传承', '亲情'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20an%20old%20handwritten%20letter%20on%20a%20wooden%20desk%20beside%20dried%20flowers%2C%20warm%20sepia%20and%20soft%20cream%20tones%2C%20tender%20nostalgic%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-family-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20quiet%20study%20with%20afternoon%20sunlight%20through%20lace%20curtains%2C%20warm%20sepia%20and%20cream%20tones%2C%20dust%20in%20the%20air%2C%20film%20grain%2C%20tender%20nostalgic%20mood%2C%20no%20text&width=1600&height=900&seq=backdrop-family-03&orientation=landscape',
    featured: false,
    synopsis: '母亲临终前留下最后一封信，却没有写下收信人的名字。三个子女为了确认这封信属于谁，被迫重新拼凑母亲的一生。影片温柔而不失力量，把“告别”拍成了一次迟到的理解，让人意识到，有些爱需要跨越生死才能被读懂。',
    editorReviewTitle: '一封没写名字的信，写给所有人',
    editorReview: '看完会想给家人打个电话的电影。它克制、真诚，不靠戏剧冲突取胜，而是靠细节里那些被忽略的温柔击中人心。',
  },
  {
    id: 'beyond-the-line',
    title: '边界之外',
    originalTitle: 'Beyond the Line',
    year: 2024,
    genres: ['剧情', '社会', '悬疑'],
    region: '美国',
    duration: 137,
    director: 'Rebecca Stone',
    cast: ['Amara Bell', 'Aaron Cole', 'Jonah Reed', 'Claire Hodges'],
    rating: 8.8,
    popularity: 98,
    addedDate: '2026-07-02',
    category: 'society',
    tags: ['移民', '伦理困境', '共同体'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20long%20border%20fence%20under%20a%20vast%20dramatic%20sky%20at%20dawn%2C%20deep%20indigo%20and%20warm%20orange%20horizon%2C%20epic%20restrained%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-society-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20vast%20desert%20landscape%20at%20dawn%20with%20a%20distant%20fence%20line%2C%20deep%20indigo%20sky%20and%20warm%20orange%20horizon%2C%20epic%20restrained%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-society-04&orientation=landscape',
    featured: true,
    synopsis: '一家人在边境线上收留了一个陌生的旅人，却因此被卷入一场关于法律与人情的两难。影片以此为切口，讨论当代社会中“我们”与“他们”的界限是如何被划定的。当规则与良知发生冲突，一个普通家庭的选择，折射出整个时代的困惑与挣扎。',
    editorReviewTitle: '界线之内是人，界线之外也是',
    editorReview: '2024 年最具讨论度的社会伦理片。导演把宏大的议题收进一个家庭的选择里，让每一个观众都无法置身事外。收尾的处理尤其高明，克制、留白，却余震不断。',
  },
  {
    id: 'end-of-honeymoon',
    title: '蜜月终点',
    originalTitle: 'End of Honeymoon',
    year: 2018,
    genres: ['爱情', '剧情'],
    region: '美国',
    duration: 110,
    director: 'Lily Carmichael',
    cast: ['Sofia Lang', 'Jared Hale', 'Miles Grant'],
    rating: 7.5,
    popularity: 64,
    addedDate: '2026-06-24',
    category: 'romance',
    tags: ['婚姻', '理想落差', '现实'],
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20an%20empty%20honeymoon%20hotel%20suite%20with%20open%20suitcases%20and%20soft%20morning%20light%2C%20muted%20blush%20and%20warm%20cream%20tones%2C%20bittersweet%20intimate%20mood%2C%20painterly%20editorial%20illustration%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=poster-romance-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20empty%20seaside%20hotel%20balcony%20at%20soft%20morning%20light%20with%20open%20suitcases%2C%20muted%20blush%20and%20warm%20cream%20tones%2C%20bittersweet%20intimate%20mood%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-romance-04&orientation=landscape',
    featured: false,
    synopsis: '蜜月结束的那一刻，理想中的婚姻才开始露出真实的模样。一对新婚夫妻在一次旅行中，被迫面对彼此在金钱、家庭与未来规划上的分歧。影片真实而不刻薄，把婚姻初期那种甜蜜与迷茫交织的状态拍得令人会心一笑，也令人心头一紧。',
    editorReviewTitle: '浪漫散场之后，生活才刚开始',
    editorReview: '一部很适合情侣一起看的电影。它不贩卖焦虑，也不美化婚姻，而是把两个人磨合的过程拍得既真实又温柔。看完之后会更懂得体谅身边的人。',
  },
];

export const getMovieById = (id: string): Movie | undefined =>
  movies.find((m) => m.id === id);

export const getFeaturedMovies = (): Movie[] => movies.filter((m) => m.featured);

export const getRelatedMovies = (movie: Movie, limit = 4): Movie[] =>
  movies
    .filter((m) => m.id !== movie.id)
    .sort((a, b) => {
      const scoreA = (a.category === movie.category ? 2 : 0) + (a.director === movie.director ? 3 : 0);
      const scoreB = (b.category === movie.category ? 2 : 0) + (b.director === movie.director ? 3 : 0);
      return scoreB - scoreA;
    })
    .slice(0, limit);